import { AgendaItem } from 'mini-agenda';

/**
 * Function to remove agenda items from store
 * @param agendaStore - The current agenda store
 * @param noOfItemsToRemove - No of items to be removed from store
 * @param endToRemove - The top/bottom end from where removal should be done
 */
export default function trimAgendaItems(
    agendaStoreItems: AgendaItem[],
    noOfItemsToRemove: number,
    shouldRemoveFromTop: boolean
) {
    if (shouldRemoveFromTop) {
        agendaStoreItems.splice(0, noOfItemsToRemove);
    } else {
        const lengthOfItems = agendaStoreItems.length;
        const noOfItemsKept = lengthOfItems - noOfItemsToRemove;
        agendaStoreItems.splice(noOfItemsKept);
    }
}
